module.exports = __webpack_public_path__ + "../assets/img/9c9b3b52e6a9f1f63e19bcd1fb8eb4a6.svg";